/**
 *
 * Asynchronously loads the component for WealthChecker
 *
 */

import { lazyLoad } from 'utils/loadable';

export const WealthChecker = lazyLoad(
  () => import('./index'),
  module => module.WealthChecker,
);
